//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { UserLoginMixin } from "@/mixins";
import { getProfileEncrypted } from "@/model/javaApi/profile.encrypt";
import { get, isObject } from "lodash";
import Logout from "./components/Logout.vue";
import UpdateInformation from "./components/UpdateInformation.vue";
export default {
  name: "personal-information",
  mixins: [UserLoginMixin],
  components: {
    Logout,
    UpdateInformation,
  },
  data() {
    return {
      /** 合规：个人资料拉取走加密接口，关闭则回退 mixin 原 getProfile */
      enableProfileEncrypt: true,
      logoutVisible: false,
      updateVisible: false,
    };
  },
  activated() {
    if (this.enableProfileEncrypt) {
      this.fetchProfileEncrypted();
    } else {
      this.getProfile();
    }
    this.logoutVisible = false;
  },
  mounted() {
    this.STATISTICS("load", "insur_mall_my_profile_page", "jr");
  },
  computed: {
    incomplete() {
      return !this.profile.name || !this.profile.idCardNo;
    },
  },
  methods: {
    /** 合规：加密版个人资料拉取（新增，不修改 mixin 内 getProfile） */
    fetchProfileEncrypted() {
      this.profileLoading = true;
      getProfileEncrypted()
        .then((res) => {
          const data = get(res, "data.data");
          if (isObject(data)) {
            this.profile = {
              ...this.profile,
              ...data,
            };
          }
        })
        .catch(() => {})
        .finally(() => {
          this.profileLoading = false;
        });
    },
    changeLogoutVisible(visible) {
      if (visible) {
        this.STATISTICS("click", "insur_mall_my_profile_account_click", "jr");
      }
      this.logoutVisible = visible;
    },
    changeUpdateVisible(visible) {
      if (visible) {
        this.STATISTICS("click", "insur_mall_my_profile_profile_click", "jr");
      }
      this.updateVisible = visible;
    },
  },
};
